import { Injectable } from "@angular/core";
import { IPreference, IPreferenceUser } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "../shared/api/api.service";
import { BaseApiService } from "../shared/api/baseApi.service";

@Injectable({
  providedIn: "root",
})
export class PreferenceApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "Preferences", // Theme !
      [], // Post route paths
      [], // Get route paths
      [], // Update route paths
      [] // Delete route paths
    );
  }

  // tslint:disable-next-line:no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  public list(context: string): Observable<any> {
    return this.api.get(`preferences/${context}`);
  }

  public update(preference: IPreference): Observable<IPreferenceUser> {
    return this.api.put("preference", preference) as Observable<IPreferenceUser>;
  }
}
